export default "__VITE_ASSET__B30k_4G4__"